import React, { Component } from 'react';
import Loader from "../utils/Loader";
import { Link } from 'react-router-dom';
import { withRouter } from '../utils/withRouter';
import { connect } from "react-redux";
import { BASE_URL, toastError } from '../utils/constants';
import { getCmsContent_action } from '../actions/cms_action/cmsAction';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            scrollPosition: 0,
            cmsMode: '',
            headerNavs: [],
            UserID: localStorage.getItem("UserID"),
            RoleID: localStorage.getItem("RoleID"),
            cmsSubheaderData: [],
            govtLogoList: [],
            downloadUrl: '',
            overflowItems: []
        };
        this.onLogout = this.onLogout.bind(this);
        this.navLogin = this.navLogin.bind(this);
        this.handleMenuOverflow = this.handleMenuOverflow.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.toggleMobileSubmenu = this.toggleMobileSubmenu.bind(this);
    }

    componentDidMount() {
        const css = `
            /* Desktop More Menu */
            #moreMenu .sub-menu .menu-item-has-children > .sub-menu,
            #moreMenu .menu-item-has-children > .sub-menu {
                left: auto !important; right: 100% !important; top: 0 !important;
            }
            #moreMenu .menu-item-has-children > a::after { transform: rotate(360deg); }
            #moreMenu { z-index: 9999; }
            #moreMenu .sub-menu { min-width: 200px; }

            /* --- Seamless CSS Ticker Animation (Replaces <marquee>) --- */
            .seamless-marquee-wrapper {
                display: flex;
                overflow: hidden;
                white-space: nowrap;
                width: 100%;
                position: relative;
            }
            .seamless-marquee-track {
                display: flex;
                width: max-content;
                animation: seamlessScroll 35s linear infinite;
            }
            .seamless-marquee-track.fast {
                animation-duration: 20s;
            }
            .seamless-marquee-track:hover, .seamless-marquee-track:active {
                animation-play-state: paused;
            }
            @keyframes seamlessScroll {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); } /* Loops exactly at halfway point */
            }
            .mobile-marquee-width {
                width: 80%;
                margin: 0 auto;
            }

            /* Mobile Off-canvas Menu */
            .tgmobile__menu {
                position: fixed; right: -100%; top: 0; width: 300px; height: 100vh;
                background: #151319; z-index: 99999; transition: all 0.4s ease;
                overflow-y: auto; padding: 30px 20px;
                display: flex; flex-direction: column;
            }
            .mobile-menu-visible .tgmobile__menu { right: 0; }
            .tgmobile__menu-backdrop {
                position: fixed; top: 0; left: 0; width: 100%; height: 100vh;
                background: rgba(0,0,0,0.7); z-index: 99998; display: none; cursor: pointer;
            }
            .mobile-menu-visible .tgmobile__menu-backdrop { display: block; }
            .tgmobile__menu .close-btn {
                position: absolute; top: 15px; right: 20px; color: white;
                cursor: pointer; font-size: 24px; z-index: 10;
            }
            .tgmobile__menu .nav-logo {
                margin-bottom: 30px; padding-bottom: 20px; border-bottom: 1px solid rgba(255,255,255,0.1);
            }
            .tgmobile__menu .navigation { list-style: none; padding: 0; margin: 0; }
            .tgmobile__menu .navigation li { position: relative; border-bottom: 1px solid rgba(255,255,255,0.08); }
            .tgmobile__menu .navigation li > a {
                display: block; padding: 12px 40px 12px 0; font-size: 15px;
                color: #fff; font-weight: 500; text-transform: capitalize;
                cursor: pointer; text-decoration: none;
            }
            .tgmobile__menu .navigation li > a:hover { color: #116469; }
            .tgmobile__menu .navigation li .sub-menu {
                display: none; padding: 0 0 0 16px; margin: 0; list-style: none;
                background: rgba(0,0,0,0.2); border-radius: 4px;
            }
            .tgmobile__menu .navigation li .sub-menu.open { display: block; }
            .tgmobile__menu .navigation li .sub-menu li { border-bottom: 1px solid rgba(255,255,255,0.05); }
            .tgmobile__menu .navigation li .sub-menu li:last-child { border-bottom: none; }
            .tgmobile__menu .navigation li .sub-menu li > a {
                font-size: 13px; padding: 10px 8px; color: rgba(255,255,255,0.8);
            }
            .tgmobile__menu .dropdown-btn {
                position: absolute; top: 8px; right: 0; width: 32px; height: 32px;
                background: rgba(255,255,255,0.1); text-align: center; line-height: 32px;
                cursor: pointer; border-radius: 4px; transition: background 0.3s;
                z-index: 5; display: flex; align-items: center; justify-content: center;
            }
            .tgmobile__menu .dropdown-btn:hover { background: rgba(17, 100, 105, 0.5); }
            .tgmobile__menu .dropdown-btn .plus-line {
                position: relative; display: block; width: 10px; height: 2px;
                background: #fff; transition: transform 0.3s;
            }
            .tgmobile__menu .dropdown-btn .plus-line::after {
                content: ''; position: absolute; width: 2px; height: 10px;
                background: #fff; top: -4px; left: 4px; transition: opacity 0.3s, transform 0.3s;
            }
            .tgmobile__menu .dropdown-btn.open { background: #116469; }
            .tgmobile__menu .dropdown-btn.open .plus-line { transform: rotate(180deg); }
            .tgmobile__menu .dropdown-btn.open .plus-line::after { opacity: 0; }
        `;
        this.styleEl = document.createElement('style');
        this.styleEl.type = 'text/css';
        this.styleEl.appendChild(document.createTextNode(css));
        document.head.appendChild(this.styleEl);

        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });

        this.handleScroll = () => {
            this.setState({ scrollPosition: window.scrollY });
        };

        if (Array.isArray(this.props.headerNavs) && this.props.headerNavs.length > 0) {
            this.setState({ headerNavs: this.props.headerNavs }, () => {
                this.handleMenuOverflow();
            });
        } else {
            this.getCmsContent(1, 'home');
        }

        const path = this.props.location?.pathname || '';
        const cmsPrefix = '/cms';
        this.setState({ cmsMode: path.includes(cmsPrefix) ? 1 : 0 });

        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener("resize", this.handleMenuOverflow);
    }

    componentDidUpdate(prevProps, prevState) {
        // Fix: Detect route changes to accurately sync cmsMode
        const path = this.props.location?.pathname || "";
        const prevPath = prevProps.location?.pathname || "";

        if (path !== prevPath) {
            const newCmsMode = path.includes('/cms') ? 1 : 0;
            if (this.state.cmsMode !== newCmsMode) {
                this.setState({ cmsMode: newCmsMode });
            }
        }

        if (prevState.headerNavs !== this.state.headerNavs || prevState.cmsMode !== this.state.cmsMode) {
            setTimeout(() => {
                this.handleMenuOverflow();
            }, 50);
        }
        if (this.props.headerNavs !== prevProps.headerNavs && Array.isArray(this.props.headerNavs)) {
            this.setState({ headerNavs: this.props.headerNavs });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener("resize", this.handleMenuOverflow);
        if (this.styleEl && this.styleEl.parentNode) this.styleEl.parentNode.removeChild(this.styleEl);
    }

    getCmsContent = async (MenuID, MenuUrl) => {
        try {
            this.setState({ isLoading: true });
            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    headerNavs: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
                    govtLogoList: data?.data[6] !== "" ? data?.data[6] : [],
                }, () => {
                    setTimeout(() => { this.handleMenuOverflow(); }, 50);
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    handleMenuOverflow = () => {
        const measureContainer = document.getElementById("measureMenu");
        const navContainer = document.getElementById("mainMenuContainer");
        if (!measureContainer || !navContainer) return;

        let newOverflowItems = [];
        const containerWidth = navContainer.offsetWidth - 100;
        let totalWidth = 0;

        Array.from(measureContainer.children).forEach(li => {
            const id = li.getAttribute("data-id");
            if (id) {
                totalWidth += li.offsetWidth;
                if (totalWidth > containerWidth) {
                    newOverflowItems.push(id);
                }
            }
        });

        const cmsEnabled = Boolean(localStorage.getItem("isVerified"));

        // Fix: Use consistent public boolean check to prevent false positives
        const isPublic = (val) => val === true || val === 1 || val === "1" || String(val).toLowerCase() === "true";
        const internalPagesExist = this.state.headerNavs.some(n => !isPublic(n.isMenuItem));

        if (cmsEnabled) {
            if (internalPagesExist && !newOverflowItems.includes("internal-pages")) {
                newOverflowItems.push("internal-pages");
            }
            if (!newOverflowItems.includes("cms-root")) {
                newOverflowItems.push("cms-root");
            }
        }

        if (this.state.overflowItems.join(',') !== newOverflowItems.join(',')) {
            this.setState({ overflowItems: newOverflowItems });
        }
    };

    onLogout() {
        localStorage.clear();
        this.props.navigate('/');
    }

    navLogin() {
        sessionStorage.setItem('isLoginClicked', true);
        this.props.navigate('/login');
    }
    runDynamicScripts() {
        //STEP 0 — Convert <a> → <span>
        // 🟢 PRE-CHECK: Detect if we are on the MediaKit page
        const isMediaKitPage = window.location.href.toLowerCase().includes("mediakit");

        // We use a regular for loop or convert to array to avoid issues while modifying DOM live
        const anchors = Array.from(document.querySelectorAll("a[href]"));

        anchors.forEach(a => {
            const href = a.getAttribute("href") || "";

            // allow router + internal (if you want these to stay as real links)
            if (href.startsWith("/") || href.startsWith("#/")) return;

            // MediaKit exception
            if (isMediaKitPage) return;

            // 🛑 kill dummy anchors
            if (href === "#" || href.startsWith("javascript:")) {
                a.removeAttribute("href");
                return;
            }

            const isVideo =
                href.match(/\.(mp4|webm|mkv|mov|m3u8)$/i) ||
                href.includes("youtube.com") ||
                href.includes("youtu.be") ||
                href.includes("vimeo.com") ||
                href.includes("dailymotion.com") ||
                href.includes("facebook.com");

            const isDoc =
                href.match(/\.(pdf|jpg|jpeg|png)$/i);

            // External NON video/doc → leave untouched (Let them be normal links)
            if (!isVideo && !isDoc && /^https?:\/\//i.test(href)) return;

            // 🔥 HARD NEUTRALIZE: REPLACE <a> WITH <span>
            const span = document.createElement("span");

            // 1. Copy inner HTML (text, images, icons)
            span.innerHTML = a.innerHTML;

            // 2. Copy all attributes (classes, IDs, data-attributes) EXCEPT href/target
            Array.from(a.attributes).forEach(attr => {
                if (attr.name !== 'href' && attr.name !== 'target') {
                    span.setAttribute(attr.name, attr.value);
                }
            });

            // 3. Set the data-href for your click listeners later
            span.setAttribute("data-href", href);

            // 4. visual styling to mimic a link behavior
            span.style.cursor = "pointer";
            span.classList.add("no-link-preview");

            // 5. Replace the <a> with the new <span> in the DOM
            if (a.parentNode) {
                a.parentNode.replaceChild(span, a);
            }
        });
        // ... [Your existing SlideToggle, Preloader, WOW, AOS, Menu code] ...
        //STEP 1 — Helper: slideToggle
        const slideToggle = (el, duration = 300) => {
            if (window.getComputedStyle(el).display === "none") {
                el.style.display = "block";
                const h = el.scrollHeight;
                el.style.overflow = "hidden";
                el.style.maxHeight = 0;
                el.style.transition = `max-height ${duration}ms ease-in-out`;
                setTimeout(() => (el.style.maxHeight = h + "px"), 10);
                setTimeout(() => {
                    el.style.removeProperty("max-height");
                    el.style.removeProperty("overflow");
                    el.style.removeProperty("transition");
                }, duration);
            } else {
                el.style.overflow = "hidden";
                el.style.maxHeight = el.scrollHeight + "px";
                el.style.transition = `max-height ${duration}ms ease-in-out`;
                setTimeout(() => (el.style.maxHeight = 0), 10);
                setTimeout(() => {
                    el.style.display = "none";
                    el.style.removeProperty("max-height");
                    el.style.removeProperty("overflow");
                    el.style.removeProperty("transition");
                }, duration);
            }
        };

        //STEP 2 — Preloader
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.style.opacity = "0";
            setTimeout(() => (preloader.style.display = "none"), 500);
        }

        //STEP 3 — WOW & AOS
        if (typeof window.WOW === "function") new window.WOW()?.init();
        if (typeof window.AOS === "object") window.AOS?.init({ duration: 1000, mirror: true });

        //STEP 4 — Mobile Menu
        const mobileMenuContainer = document.querySelector(".tgmobile__menu");

        if (mobileMenuContainer) {
            document.querySelectorAll(".tgmenu__wrap .navigation li.menu-item-has-children").forEach(li => {
                if (!li.querySelector(".dropdown-btn")) {
                    li.insertAdjacentHTML("beforeend", '<div class="dropdown-btn"><span class="plus-line"></span></div>');
                }
            });

            const mobileMenuOuter = document.querySelector(".tgmobile__menu-box .tgmobile__menu-outer");
            if (mobileMenuOuter && !mobileMenuOuter.innerHTML) {
                const mainMenu = document.querySelector(".tgmenu__wrap .tgmenu__main-menu")?.innerHTML;
                if (mainMenu) mobileMenuOuter.innerHTML = mainMenu;
            }

            document.querySelectorAll(".tgmobile__menu li.menu-item-has-children .dropdown-btn").forEach(btn => {
                btn.addEventListener("click", function () {
                    this.classList.toggle("open");
                    const submenu = this.previousElementSibling;
                    if (submenu && submenu.tagName === "UL") slideToggle(submenu, 300);
                });
            });

            document.querySelector(".mobile-nav-toggler")?.addEventListener("click", () => {
                document.body.classList.add("mobile-menu-visible");
            });

            document.querySelectorAll(".tgmobile__menu-backdrop, .tgmobile__menu .close-btn").forEach(el =>
                el.addEventListener("click", () => document.body.classList.remove("mobile-menu-visible"))
            );
        }

        // STEP 5 — Sticky Header
        window.addEventListener("scroll", () => {
            const y = window.scrollY;
            const sticky = document.getElementById("sticky-header");
            const scrollBtn = document.querySelector(".scroll-to-target");
            const headerHeight = document.getElementById("header-fixed-height");

            if (y < 245) {
                sticky?.classList.remove("sticky-menu");
                scrollBtn?.classList.remove("open");
                headerHeight?.classList.remove("active-height");
            } else {
                sticky?.classList.add("sticky-menu");
                scrollBtn?.classList.add("open");
                headerHeight?.classList.add("active-height");
            }
        });

        document.querySelector(".scroll-to-target")?.addEventListener("click", function () {
            const t = document.querySelector(this.getAttribute("data-target"));
            if (t) window.scrollTo({ top: t.offsetTop, behavior: "smooth" });
        });

        //STEP 6 — Backgrounds
        document.querySelectorAll("[data-background]").forEach(el => {
            el.style.backgroundImage = `url(${el.getAttribute("data-background")})`;
        });
        document.querySelectorAll("[data-bg-color]").forEach(el => {
            el.style.backgroundColor = el.getAttribute("data-bg-color");
        });

        //STEP 7 — Search Popup
        document.querySelector(".search-open-btn")?.addEventListener("click", () => {
            document.querySelector(".search__popup")?.classList.add("search-opened");
            document.querySelector(".search-popup-overlay")?.classList.add("search-popup-overlay-open");
        });

        document.querySelector(".search-close-btn")?.addEventListener("click", () => {
            document.querySelector(".search__popup")?.classList.remove("search-opened");
            document.querySelector(".search-popup-overlay")?.classList.remove("search-popup-overlay-open");
        });

        //STEP 8 — Offcanvas Menu
        document.querySelector(".menu-tigger")?.addEventListener("click", e => {
            e.preventDefault();
            document.querySelector(".offCanvas__info")?.classList.add("active");
            document.querySelector(".offCanvas__overly")?.classList.add("active");
        });

        document.querySelectorAll(".menu-close, .offCanvas__overly").forEach(el => {
            el.addEventListener("click", () => {
                document.querySelector(".offCanvas__info")?.classList.remove("active");
                document.querySelector(".offCanvas__overly")?.classList.remove("active");
                document.querySelector(".offCanvas__info1")?.classList.remove("active");
            });
        });

        //STEP 9 — Swiper
        if (window.Swiper) {
            const initSwiper = (selector, options) => {
                const el = document.querySelector(selector);
                if (!el) return;
                if (el.swiper) return; // Prevent double-initialization
                try {
                    el.swiper = new window.Swiper(selector, options);
                } catch (err) {
                    console.error("Swiper init error on", selector, err);
                }
            };

            initSwiper('.slider-active', {
                spaceBetween: 0,
                effect: "fade",
                loop: true,
                autoplay: { delay: 6000 }
            });

            initSwiper('.slider-active-two', {
                spaceBetween: 0,
                effect: "fade",
                navigation: {
                    nextEl: ".slider-button-next",
                    prevEl: ".slider-button-prev"
                }
            });

            initSwiper('.slider-active-three', {
                spaceBetween: 0,
                effect: "fade",
                loop: true,
                autoplay: { delay: 6000 }
            });

            initSwiper('.project_active', {
                slidesPerView: 3,
                spaceBetween: 24,
                loop: true,
                navigation: {
                    nextEl: ".project-button-next",
                    prevEl: ".project-button-prev"
                },
                breakpoints: {
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 3 }
                }
            });

            initSwiper('.brand-active', {
                slidesPerView: 5,
                spaceBetween: 24,
                loop: true,
                breakpoints: {
                    0: { slidesPerView: 2 },
                    576: { slidesPerView: 3 },
                    768: { slidesPerView: 3 },
                    992: { slidesPerView: 4 },
                    1200: { slidesPerView: 5 }
                }
            });

            initSwiper('.testimonial__active', {
                slidesPerView: 2,
                spaceBetween: 24,
                loop: true,
                autoplay: { delay: 6000 },
                navigation: {
                    nextEl: ".testimonial-button-next",
                    prevEl: ".testimonial-button-prev"
                },
                breakpoints: {
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 1 },
                    768: { slidesPerView: 2 }
                }
            });

            initSwiper('.AwardSwiper', {
                slidesPerView: 3,
                spaceBetween: 24,
                loop: true,
                autoplay: { delay: 6000 },
                navigation: {
                    nextEl: ".testimonial-button-next",
                    prevEl: ".testimonial-button-prev"
                },
                breakpoints: {
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 3 }
                }
            });
        }


        //ISOTOPE
        if (window.Isotope && window.imagesLoaded) {
            const grid = document.querySelector('.project-active-two');
            if (grid) {
                window.imagesLoaded(grid, () => {
                    const iso = new window.Isotope(grid, {
                        itemSelector: '.grid-item',
                        percentPosition: true,
                        masonry: { columnWidth: '.grid-item' }
                    });

                    document.querySelectorAll('.project__menu-nav button').forEach(btn => {
                        btn.addEventListener('click', function (e) {
                            e.preventDefault();

                            const filterValue = this.getAttribute('data-filter');
                            iso.arrange({ filter: filterValue });

                            document.querySelector('.project__menu-nav button.active')?.classList.remove('active');
                            this.classList.add('active');
                        });
                    });
                });
            }
        }

        //STEP 11 — FULL COUNTDOWN SYSTEM
        const setupCountdown = (config) => {
            const targetDate = new Date(config.date);
            let interval = null;

            const update = () => {
                const now = new Date();
                const remaining = targetDate - now;

                if (remaining <= 0) {
                    if (interval) clearInterval(interval);
                    if (config.days) config.days.textContent = "00";
                    if (config.hours) config.hours.textContent = "00";
                    if (config.minutes) config.minutes.textContent = "00";
                    if (config.seconds) config.seconds.textContent = "00";
                    return;
                }

                const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
                const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

                if (config.days) config.days.textContent = days.toString().padStart(2, "0");
                if (config.hours) config.hours.textContent = hours.toString().padStart(2, "0");
                if (config.minutes) config.minutes.textContent = minutes.toString().padStart(2, "0");
                if (config.seconds) config.seconds.textContent = seconds.toString().padStart(2, "0");
            };

            interval = setInterval(update, 1000);
            update();

            // trigger
            document.querySelectorAll(config.triggerSelector).forEach(trigger => {
                trigger.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (new Date() >= targetDate) {
                        window.open(config.redirectUrl, "_blank");
                    } else {
                        document.getElementById(config.modalId)?.classList.add("active");
                    }
                });
            });

            document.getElementById(config.closeId)?.addEventListener("click", () => {
                document.getElementById(config.modalId)?.classList.remove("active");
            });
        };

        // Your 3 countdowns
        setupCountdown({
            date: "2025-02-21T12:00:00",
            triggerSelector: ".register_click, .booking_click",
            modalId: "timer_Modal1",
            closeId: "close_timer_Modal1",
            redirectUrl: "https://india-itme.com/#/ITME2026",
            days: document.querySelector(".days1 .number1"),
            hours: document.querySelector(".hours1 .number1"),
            minutes: document.querySelector(".minutes1 .number1"),
            seconds: document.querySelector(".seconds1 .number1"),
        });

        const storedDate = sessionStorage.getItem("visitor_header_footer_click");

        // 2. Fallback to a hardcoded date if the session storage is empty
        const countdownDate = storedDate ? storedDate : "2026-04-30T18:00:00";

        // 3. Initialize the countdown
        setupCountdown({
            date: countdownDate,
            triggerSelector: ".visitor_header_footer_click",
            modalId: "timer_Modal",
            closeId: "close_timer_Modal",
            redirectUrl: "https://india-itme.com/#/visitorregistration/ITME2026",
            days: document.querySelector(".days .number"),
            hours: document.querySelector(".hours .number"),
            minutes: document.querySelector(".minutes .number"),
            seconds: document.querySelector(".seconds .number"),
        });

        setupCountdown({
            date: "2025-02-21T12:00:00",
            triggerSelector: ".login_btn_click",
            modalId: "timer_Modal2",
            closeId: "close_timer_Modal2",
            redirectUrl: "https://india-itme.com/#/login/ITME2026",
            days: document.querySelector(".days2 .number2"),
            hours: document.querySelector(".hours2 .number2"),
            minutes: document.querySelector(".minutes2 .number2"),
            seconds: document.querySelector(".seconds2 .number2"),
        });

        //STEP 12 — jQuery Plugins
        if (window.jQuery) {
            const $ = window.jQuery;

            if ($.fn.magnificPopup) {
                $(".popup-image").magnificPopup({ type: "image", gallery: { enabled: true } });
            }

            if ($.fn.marquee) {
                $(".marquee_mode").marquee({ speed: 20, gap: 35, direction: "left", duplicated: true, pauseOnHover: true });
            }
        }

        //STEP 13 — PDF / IMAGE Viewer (UPDATED)
        document.querySelectorAll('span[data-href]').forEach(span => {
            const url = span.getAttribute("data-href") || "";

            // Check for PDF (Case Insensitive)
            if (url.match(/\.pdf$/i) || url.match(/\.pdf\?/i)) {
                span.addEventListener("click", () => this.openPdfViewer(url, 1));
            }

            // Check for Images (Case Insensitive)
            if (url.match(/\.(jpg|jpeg|png)$/i) || url.match(/\.(jpg|jpeg|png)\?/i)) {
                span.addEventListener("click", () => this.openPdfViewer(url, 2));
            }
        });

        // STEP 13.1 — VIDEO DETECTION (Updated for Plyr)
        document.querySelectorAll('span[data-href]').forEach(span => {
            let url = span.getAttribute("data-href") || "";

            const isVideo =
                url.match(/\.(mp4|webm|mkv|mov|m3u8)$/i) ||
                url.includes("youtube.com") ||
                url.includes("youtu.be") ||
                url.includes("vimeo.com") ||
                url.includes("dailymotion.com") ||
                url.includes("facebook.com");

            if (isVideo) {
                // Clean tracking params
                if (url.includes("?si=")) url = url.split("?si=")[0];
                if (url.includes("&t=")) url = url.split("&t=")[0];

                span.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log("%c[VIDEO] Loading via Plyr CDN →", "color:green;font-weight:bold;", url);

                    this.setState({
                        videoModalOpen: true,
                        videoUrl: url,
                        videoReady: false // Reset ready state
                    });
                });
            }
        });

        // STEP 14 — Internal Anchor Scroll (SAFE)
        document.querySelectorAll('span[data-href^="#"]').forEach(span => {
            const href = span.getAttribute("data-href");

            // 🛑 HARD GUARDS
            if (!href || href === "#") return;
            if (href.startsWith("#/")) return;
            if (href.includes("/")) return;

            span.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();

                const target = document.querySelector(href);
                if (!target) return;

                const offset = document.getElementById("site-header")?.offsetHeight || 80;
                const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: y, behavior: "smooth" });
            });
        });

        //STEP 15 — External URLs BUT EXCLUDE VIDEO/DOC HANDLED LINKS
        document.querySelectorAll('span[data-href^="http"]').forEach(span => {
            const href = span.getAttribute("data-href") || "";

            const isVideo =
                href.match(/\.(mp4|webm|mkv|mov|m3u8)$/i) ||
                href.includes("youtube.com") ||
                href.includes("youtu.be") ||
                href.includes("vimeo.com") ||
                href.includes("dailymotion.com") ||
                href.includes("facebook.com");

            // 🟢 Stop redirecting externally for VIDEO or DOC links
            const isDocLink = href.match(/\.(pdf|jpg|jpeg|png)$/i);

            if (isVideo || isDocLink) return;

            // Otherwise, open strictly external generic links
            span.addEventListener("click", () => window.open(href, "_blank"));
        });

        // STEP 16 — CSS helper (Updated for Plyr Security)
        const style = document.createElement("style");
        style.textContent = `
            .no-link-preview { text-decoration: none; color: inherit; }
            .no-link-preview:hover { opacity: 0.85; }

            /* 🛡️ HIDE PLYR DOWNLOAD BUTTONS (Extra Safety) */
            .plyr__download { display: none !important; }
            
            /* 🛡️ PREVENT SELECTION */
            .noselect {
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -khtml-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }
        `;
        document.head.appendChild(style);
    }
    handleMenuClick(MenuID, Url, Title) {
        document.body.classList.remove("mobile-menu-visible");

        // 1. Target "Visitor Registration" specifically
        if (Title === 'Visitor Registration') {
            const storedDate = sessionStorage.getItem("visitor_header_footer_click");
            const countdownDate = new Date(storedDate || "2026-04-30T18:00:00");
            const now = new Date();

            if (now < countdownDate) {
                // --- CASE A: Countdown active -> Show Modal ---
                const modal = document.getElementById("timer_Modal");
                if (modal) {
                    modal.classList.add("active");
                    // Re-init the display numbers just in case
                    this.runDynamicScripts();
                }
                return; // Stop further execution/navigation
            } else {
                // --- CASE B: Expired -> Open Redirect ---
                window.open("https://india-itme.com/#/visitorregistration/ITME2026", "_blank");
                return;
            }
        }

        // 2. Standard Navigation Logic for other menu items
        localStorage.setItem("MenuID", MenuID);
        localStorage.setItem("Url", Url);

        const trimmedUrl = (Url || '').trim();
        const externalUrlPattern = /^(https?:\/\/|www\.|ftp:\/\/|mailto:)/i;

        if (externalUrlPattern.test(trimmedUrl)) {
            window.open(trimmedUrl, '_blank');
        } else {
            const normalizedUrl = trimmedUrl.startsWith('/') ? trimmedUrl : '/' + trimmedUrl;
            const basePath = this.props.location.pathname.includes('/cms') ? '/cms/manage' : '';
            const newPath = `${basePath}${normalizedUrl}&${MenuID}`;
            this.props.navigate(newPath);
        }
    }

    toggleMobileSubmenu(e) {
        e.preventDefault();
        e.stopPropagation();
        const button = e.currentTarget;
        const parentLi = button.closest('li');
        const submenu = parentLi ? parentLi.querySelector('.sub-menu') : null;
        button.classList.toggle('open');
        if (submenu) {
            submenu.classList.toggle('open');
        }
    }

    renderMobileMenu() {
        const { headerNavs } = this.state;
        const internalPages = [];

        // Fix: Replace tight `cmsMode` coupling with `isVerifiedAdmin` to guarantee it shows for all admins
        const isVerifiedAdmin = Boolean(localStorage.getItem('isVerified'));
        const isPublic = (val) => val === true || val === 1 || val === "1" || String(val).toLowerCase() === "true";

        const filteredNavs = headerNavs?.filter(item => item.isActive && item.isPublish) || [];
        const parents = filteredNavs?.filter(item => item.ParentID === null) || [];
        const childrenMap = {};

        filteredNavs?.forEach(item => {
            if (item.ParentID !== null) {
                if (!childrenMap[item.ParentID]) childrenMap[item.ParentID] = [];
                childrenMap[item.ParentID].push(item);
            }
        });

        const menuItems = parents
            ?.sort((a, b) => a.Sequence - b.Sequence)
            ?.map((parent) => {
                const hasChildren = (childrenMap[parent.MenuID] || []).length > 0;
                const isPublicItem = isPublic(parent.isMenuItem);
                const showMenu = isPublicItem || (hasChildren && (childrenMap[parent.MenuID] || []).some(c => isPublic(c.isMenuItem)));

                if (!isPublicItem && isVerifiedAdmin) {
                    internalPages.push(parent);
                }

                if (!showMenu) return null;

                if (hasChildren) {
                    const childItems = childrenMap[parent.MenuID]
                        ?.sort((a, b) => a.Sequence - b.Sequence)
                        ?.map(child => {
                            if (!isPublic(child.isMenuItem) && isVerifiedAdmin) {
                                internalPages.push(child);
                                return null;
                            }
                            if (!isPublic(child.isMenuItem)) return null;

                            return (
                                <li key={`mobile-child-${child.MenuID}`}>
                                    <a onClick={() => this.handleMenuClick(child.MenuID, child.Url, child.Title)}>
                                        {child.Title}
                                    </a>
                                </li>
                            );
                        })
                        .filter(Boolean);

                    if (childItems.length === 0 && !isPublicItem) return null;

                    return (
                        <li key={`mobile-${parent.MenuID}`} className="menu-item-has-children">
                            <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url, parent.Title)}>
                                {parent.Title}
                            </a>
                            {childItems.length > 0 && (
                                <ul className="sub-menu">
                                    {childItems}
                                </ul>
                            )}
                            {childItems.length > 0 && (
                                <div className="dropdown-btn" onClick={this.toggleMobileSubmenu}>
                                    <span className="plus-line"></span>
                                </div>
                            )}
                        </li>
                    );
                }

                return (
                    <li key={`mobile-${parent.MenuID}`}>
                        <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url, parent.Title)}>
                            {parent.Title}
                        </a>
                    </li>
                );
            })
            .filter(Boolean);

        if (isVerifiedAdmin) {
            menuItems.unshift(
                <li key="mobile-editor-home">
                    <Link to="/cms/manage" onClick={() => document.body.classList.remove("mobile-menu-visible")}>
                        Editor Home
                    </Link>
                </li>
            );
        }

        if (isVerifiedAdmin && internalPages.length > 0) {
            menuItems.push(
                <li key="mobile-internal-pages" className="menu-item-has-children">
                    <a>Internal Pages</a>
                    <ul className="sub-menu">
                        {internalPages.map((item) => (
                            <li key={`mobile-internal-${item.MenuID}`}>
                                <a onClick={() => this.handleMenuClick(item.MenuID, item.Url, item.Title)}>
                                    {item.Title}
                                </a>
                            </li>
                        ))}
                    </ul>
                    <div className="dropdown-btn" onClick={this.toggleMobileSubmenu}>
                        <span className="plus-line"></span>
                    </div>
                </li>
            );
        }

        if (isVerifiedAdmin) {
            menuItems.push(
                <li key="mobile-cms-menu" className="menu-item-has-children">
                    <a>CMS</a>
                    <ul className="sub-menu">
                        <li>
                            <Link to="/cms/manage" onClick={() => document.body.classList.remove("mobile-menu-visible")}>
                                Switch to Editor Mode
                            </Link>
                        </li>
                        <li>
                            <Link to="/cms/header" onClick={() => document.body.classList.remove("mobile-menu-visible")}>
                                Menu Settings
                            </Link>
                        </li>
                        <li>
                            <a onClick={() => { document.body.classList.remove("mobile-menu-visible"); this.onLogout(); }}>
                                Logout
                            </a>
                        </li>
                    </ul>
                    <div className="dropdown-btn" onClick={this.toggleMobileSubmenu}>
                        <span className="plus-line"></span>
                    </div>
                </li>
            );
        }

        return menuItems;
    }

    render() {
        const { isLoading, headerNavs, cmsSubheaderData, govtLogoList, downloadUrl, overflowItems } = this.state;

        const disclaimerTextDesktop = (
            <span style={{ fontSize: "14px", color: "#fff", fontWeight: "500", paddingRight: "60px" }}>
                <b>Disclaimer and Ownership:</b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner.
            </span>
        );

        const disclaimerTextMobile = (
            <span style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", fontWeight: "400", paddingRight: "60px" }}>
                <b>Disclaimer and Ownership:</b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner.
            </span>
        );

        const mobileBtnsArray = cmsSubheaderData
            .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType == "BTN")
            .map(item => (
                <a
                    key={`mobile-btn-${item.SubheaderID}`}
                    className="btn-blinker border p-1 px-3 rounded-4 fw-normal mx-2"
                    href={item.Link} target="_blank" rel="noopener noreferrer"
                    style={{ fontSize: "13px", whiteSpace: "nowrap", display: "inline-block", color: '#fff', textDecoration: 'none' }}
                >
                    {item.SubheaderName}
                </a>
            ));

        const mobileBtnsContent = (
            <div style={{ paddingRight: "40px", display: "flex" }}>
                {mobileBtnsArray}
            </div>
        );

        return (
            <>
                {isLoading && <Loader />}
                <header>
                    {/* --- Mobile Layout: Top Flowing CTA Buttons --- */}
                    {mobileBtnsArray.length > 0 && (
                        <div className="d-block d-lg-none w-100 py-2" style={{ backgroundColor: "#151319", borderBottom: "1px solid rgba(255,255,255,0.1)", position: 'relative', zIndex: 1050 }}>
                            <div className="seamless-marquee-wrapper mobile-marquee-width">
                                <div className="seamless-marquee-track fast">
                                    {mobileBtnsContent}
                                    {mobileBtnsContent}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* === Top Header Container === */}
                    <div className="tg-header__top d-none d-lg-block">
                        <div className="container-fluid px-3">
                            <div className="d-flex align-items-center justify-content-between flex-nowrap">
                                {/* LEFT: Social / Contact icons */}
                                <div className="d-flex align-items-center flex-shrink-0">
                                    {cmsSubheaderData?.length > 0 && (
                                        <ul className="list-wrap mb-0 d-flex align-items-center flex-nowrap">
                                            {cmsSubheaderData
                                                .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType === "SM")
                                                .map(item => {
                                                    let iconClass = '';
                                                    let href = item.Link;
                                                    switch (item.SocialType) {
                                                        case 'Email': iconClass = 'fas fa-envelope'; href = `mailto:${item.Link}`; break;
                                                        case 'Phone': iconClass = 'fas fa-phone'; href = `tel:${item.Link}`; break;
                                                        case 'Instagram': iconClass = 'fab fa-instagram'; break;
                                                        case 'Facebook': iconClass = 'fab fa-facebook-f'; break;
                                                        case 'LinkedIn': iconClass = 'fab fa-linkedin-in'; break;
                                                        case 'Twitter': iconClass = 'fab fa-twitter'; break;
                                                        case 'Youtube': iconClass = 'fab fa-youtube'; break;
                                                        default: iconClass = '';
                                                    }
                                                    const isSpecialLink = href.startsWith('mailto:') || href.startsWith('tel:');
                                                    if (!isSpecialLink && !/^https?:\/\//i.test(href)) {
                                                        href = `https://${href}`;
                                                    }
                                                    return (
                                                        <li key={item.SubheaderID} className="me-3">
                                                            <a href={href} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center">
                                                                {iconClass && <i className={iconClass} style={{ fontSize: "14px", marginRight: "5px" }} />}
                                                                <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>{item.SubheaderName}</span>
                                                            </a>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    )}
                                </div>

                                {/* CENTER: Seamless CSS Marquee (Desktop) */}
                                <div className="flex-grow-1 px-3" style={{ minWidth: 0 }}>
                                    <div className="seamless-marquee-wrapper">
                                        <div className="seamless-marquee-track">
                                            {disclaimerTextDesktop}
                                            {disclaimerTextDesktop}
                                        </div>
                                    </div>
                                </div>

                                {/* RIGHT: CTA Buttons */}
                                <div className="d-flex align-items-center flex-shrink-0">
                                    {cmsSubheaderData
                                        .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType == "BTN")
                                        .map(item => (
                                            <a
                                                key={item.SubheaderID}
                                                className="btn-blinker border p-1 px-3 rounded-4 fw-normal ms-2"
                                                href={item.Link} target="_blank" rel="noopener noreferrer"
                                                style={{ fontSize: "12px", whiteSpace: "nowrap" }}
                                            >
                                                {item.SubheaderName}
                                            </a>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* === Sticky Header === */}
                    <div id="header-fixed-height" />
                    <div id="sticky-header" className="tg-header__area" style={{ padding: '10px 0px', paddingTop: '10px' }}>

                        {/* Main Container Nav Wrapper */}
                        <div className="container custom-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="tgmenu__wrap">

                                        {/* Govt Logos */}
                                        {govtLogoList?.length > 0 && (
                                            <div className="govt_logo text-end mb-2 d-flex justify-content-end align-items-center">
                                               Supported by: 
                                                <img  src="https://corporate.india-itme.com/itme2026/document/Static/1/Ministry_of_textiles_Logo.png" alt="Govt Logo" style={{ height: "40px", marginLeft: "10px" }} />
                                                <img  src="assets/img/govtLogo1.png" alt="Govt Logo" style={{ height: "40px", marginLeft: "10px" }} />
                                               {/* {govtLogoList.filter(d => d.isActive == 1 && d.isPublish == 1).map((logo, index) => {
                                                    const imgSrc = logo.GovtLogoFilepath
                                                        ? `${downloadUrl}/${logo.GovtLogoFilepath.replace(/\\/g, "/")}`
                                                        : "https://via.placeholder.com/150x80?text=Logo";
                                                    const imgElement = (
                                                        <img key={index} src={imgSrc} alt="Govt Logo" style={{ height: "40px", marginLeft: "10px" }} />
                                                    );
                                                    return logo.Link
                                                        ? <a key={index} target="_blank" href={logo.Link}>{imgElement}</a>
                                                        : imgElement;
                                                })} */}
                                            </div>
                                        )}

                                        <nav className="tgmenu__nav container-fluid px-0 w-100">
                                            <div className="row align-items-center g-0"> {/* g-0 removes unwanted gutters for true full-width */}

                                                {/* Logo (Col-2 Desktop) */}
                                                <div className="col-6 col-lg-3 d-flex justify-content-start align-items-center ps-4">
                                                    <div className="logo">
                                                        <Link to="/">
                                                            <img src="https://corporate.india-itme.com/itme2026/document/Static/1/logo_4.png" alt="Logo" />
                                                        </Link>
                                                    </div>
                                                </div>

                                                {/* Desktop Nav (Col-8 Desktop) — hidden on mobile */}
                                                <div id="mainMenuContainer" className="col-lg-8 d-none d-lg-block">
                                                    <div className="tgmenu__navbar-wrap tgmenu__main-menu d-flex justify-content-center">
                                                        {(() => {
                                                            const internalPages = [];
                                                            const filteredNavs = headerNavs?.filter(item => item.isActive && item.isPublish);
                                                            const parents = filteredNavs?.filter(item => item.ParentID === null);
                                                            const childrenMap = {};

                                                            const isVerifiedAdmin = Boolean(localStorage.getItem('isVerified'));
                                                            const isPublic = (val) => val === true || val === 1 || val === "1" || String(val).toLowerCase() === "true";

                                                            filteredNavs?.forEach(item => {
                                                                if (item.ParentID !== null) {
                                                                    if (!childrenMap[item.ParentID]) childrenMap[item.ParentID] = [];
                                                                    childrenMap[item.ParentID].push(item);
                                                                }
                                                            });

                                                            // 1. Build all top-level items
                                                            let allItems = parents?.sort((a, b) => a.Sequence - b.Sequence)?.map((parent) => {
                                                                const hasChildren = childrenMap[parent.MenuID]?.length > 0;
                                                                const isPublicItem = isPublic(parent.isMenuItem);
                                                                const showMenu = isPublicItem || (hasChildren && childrenMap[parent.MenuID].some(c => isPublic(c.isMenuItem)));

                                                                if (!isPublicItem && isVerifiedAdmin) internalPages.push(parent);
                                                                if (!showMenu) return null;

                                                                if (hasChildren) {
                                                                    return (
                                                                        <li key={parent.MenuID} data-id={String(parent.MenuID)} className="menu-item-has-children">
                                                                            <a style={{ fontSize: '13px', cursor: 'pointer' }}>{parent.Title}</a>
                                                                            <ul className="sub-menu">
                                                                                {childrenMap[parent.MenuID]?.sort((a, b) => a.Sequence - b.Sequence)?.map(child => {
                                                                                    if (!isPublic(child.isMenuItem) && isVerifiedAdmin) {
                                                                                        internalPages.push(child);
                                                                                        return null;
                                                                                    }
                                                                                    if (!isPublic(child.isMenuItem)) return null;

                                                                                    return (
                                                                                        <li key={child.MenuID}>
                                                                                            <a onClick={() => this.handleMenuClick(child.MenuID, child.Url, child.Title)} style={{ cursor: 'pointer', fontSize: '13px' }}>
                                                                                                {child.Title}
                                                                                            </a>
                                                                                        </li>
                                                                                    );
                                                                                })}
                                                                            </ul>
                                                                        </li>
                                                                    );
                                                                }

                                                                return (
                                                                    <li key={parent.MenuID} data-id={String(parent.MenuID)}>
                                                                        <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url, parent.Title)} style={{ cursor: 'pointer', fontSize: '13px' }}>
                                                                            {parent.Title}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            }).filter(Boolean) || [];

                                                            // 2. Internal Pages logic
                                                            if (isVerifiedAdmin && internalPages.length > 0) {
                                                                allItems.push(
                                                                    <li key="internal-pages" data-id="internal-pages" className="menu-item-has-children for-cms">
                                                                        <a style={{ cursor: 'pointer' }}>Internal Pages</a>
                                                                        <ul className="sub-menu">
                                                                            {internalPages.map((item) => (
                                                                                <li key={item.MenuID}>
                                                                                    <a onClick={() => this.handleMenuClick(item.MenuID, item.Url, item.Title)} style={{ cursor: 'pointer', fontSize: '13px' }}>
                                                                                        {item.Title}
                                                                                    </a>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </li>
                                                                );
                                                            }

                                                            // 3. CMS Menu logic
                                                            if (isVerifiedAdmin) {
                                                                allItems.push(
                                                                    <li key="cms-root" data-id="cms-root" className="menu-item-has-children for-cms">
                                                                        <a style={{ fontSize: '13px', cursor: 'pointer' }}>CMS</a>
                                                                        <ul className="sub-menu">
                                                                            <li><Link to="/cms/manage">Switch to Editor Mode</Link></li>
                                                                            <li><Link to="/cms/header">Menu Settings</Link></li>
                                                                            <li><a onClick={() => this.onLogout()} style={{ cursor: 'pointer' }}>Logout</a></li>
                                                                        </ul>
                                                                    </li>
                                                                );
                                                            }

                                                            const visibleItems = allItems.filter(item => !overflowItems.includes(item.props['data-id']));
                                                            const moreItems = allItems.filter(item => overflowItems.includes(item.props['data-id']));

                                                            return (
                                                                <>
                                                                    {/* Measuring list */}
                                                                    <ul id="measureMenu" className="navigation d-flex gap-2 flex-nowrap" style={{ visibility: 'hidden', position: 'absolute', top: '-9999px', pointerEvents: 'none' }}>
                                                                        {allItems}
                                                                    </ul>

                                                                    {/* Actual Displayed Menu — using w-100 to ensure it fills the col-lg-8 */}
                                                                    <ul id="mainMenu" className="navigation d-flex align-items-center justify-content-center gap-3 flex-nowrap w-100">
                                                                        {visibleItems}

                                                                        {moreItems.length > 0 && (
                                                                            <li id="moreMenu" className="menu-item-has-children">
                                                                                <a style={{ cursor: 'pointer', fontSize: '13px' }}>More</a>
                                                                                <ul className="sub-menu">
                                                                                    {moreItems}
                                                                                </ul>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                </div>

                                                {/* Right Action (Col-2 Desktop) */}
                                                <div className="col-6 col-lg-1 d-flex justify-content-end align-items-center pe-4">
                                                    <div className="tgmenu__action d-none d-lg-block">
                                                        <ul className="list-wrap m-0">
                                                            <li>
                                                                <a href="https://india-itme.com/#/login/ITME2026" target="_blank" rel="noopener noreferrer"
                                                                    className="btn border-btn my_login_btn login_btn_click"
                                                                    style={{ padding: '8px 20px', marginTop: '0px' }}>
                                                                    Login
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    {/* Hamburger — mobile only */}
                                                    <div
                                                        className="mobile-nav-toggler d-block d-lg-none ms-3"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => document.body.classList.add("mobile-menu-visible")}
                                                    >
                                                        <i className="fas fa-bars" style={{ fontSize: '24px', color: 'inherit' }} />
                                                    </div>
                                                </div>

                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {/* === Mobile Off-canvas Menu === */}
                <div className="tgmobile__menu">
                    <nav className="tgmobile__menu-box d-flex flex-column h-100">
                        <div className="close-btn" onClick={() => document.body.classList.remove("mobile-menu-visible")}>
                            <i className="fas fa-times" />
                        </div>
                        <div className="nav-logo">
                            <Link to="/" onClick={() => document.body.classList.remove("mobile-menu-visible")}>
                                <img src="https://corporate.india-itme.com/itme2026/document/Static/1/logo_4.png" alt="Logo" style={{ maxWidth: '180px' }} />
                            </Link>
                        </div>

                        {/* Navigation Links Area */}
                        <div className="tgmobile__menu-outer flex-grow-1" style={{ justifyContent: 'flex-end' }}>
                            <ul className="navigation">
                                {this.renderMobileMenu()}
                            </ul>
                        </div>

                        {/* Mobile Offcanvas Footer: Social Icons, Disclaimer, & Login */}
                        <div className="mobile-offcanvas-footer mt-auto pt-4" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>

                            {/* Social Media Links */}
                            <div className="d-flex justify-content-center gap-3 mb-3">
                                {cmsSubheaderData
                                    .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType === "SM")
                                    .map(item => {
                                        let iconClass = '';
                                        let href = item.Link;
                                        switch (item.SocialType) {
                                            case 'Email': iconClass = 'fas fa-envelope'; href = `mailto:${item.Link}`; break;
                                            case 'Phone': iconClass = 'fas fa-phone'; href = `tel:${item.Link}`; break;
                                            case 'Instagram': iconClass = 'fab fa-instagram'; break;
                                            case 'Facebook': iconClass = 'fab fa-facebook-f'; break;
                                            case 'LinkedIn': iconClass = 'fab fa-linkedin-in'; break;
                                            case 'Twitter': iconClass = 'fab fa-twitter'; break;
                                            case 'Youtube': iconClass = 'fab fa-youtube'; break;
                                            default: iconClass = '';
                                        }
                                        const isSpecialLink = href.startsWith('mailto:') || href.startsWith('tel:');
                                        if (!isSpecialLink && !/^https?:\/\//i.test(href)) {
                                            href = `https://${href}`;
                                        }
                                        return (
                                            <a key={`mob-sm-${item.SubheaderID}`} href={href} target="_blank" rel="noopener noreferrer" className="text-white" style={{ fontSize: "18px" }}>
                                                {iconClass && <i className={iconClass} />}
                                            </a>
                                        );
                                    })}
                            </div>

                            {/* Seamless CSS Marquee (Mobile Footer) */}
                            <div className="mb-3 px-1">
                                <div className="seamless-marquee-wrapper">
                                    <div className="seamless-marquee-track">
                                        {disclaimerTextMobile}
                                        {disclaimerTextMobile}
                                    </div>
                                </div>
                            </div>

                            {/* Login Button */}
                            <div className="text-center pb-3">
                                <a
                                    href="https://india-itme.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary w-100 p-2"
                                >
                                    Login
                                </a>
                            </div>
                        </div>
                    </nav>
                </div>

                <div
                    className="tgmobile__menu-backdrop"
                    onClick={() => document.body.classList.remove("mobile-menu-visible")}
                />
            </>
        );
    }
}

export default withRouter(connect(null, { getCmsContent_action })(Header));